import endSession from 'owa-feedback-manager-actions/lib/actions/endSession';
import store from 'owa-feedback-manager-store/lib/store/locationFeedbackManagerStore';
import { action } from 'satcheljs/lib/legacy';

/**
 * Resets the location feedback manager store. This is called when compose state is reset (ie then compose is closed).
 * it will log and End session and clear the store
 */
export default action('resetLocationFeedbackManager')(function resetLocationFeedbackManager() {
    endSession(store.feedbackManagerState);
    store.feedbackManagerState = null;
});
